module.exports = __webpack_public_path__ + "static/media/RD.b206a829.png";